/* eslint-disable no-prototype-builtins */
/*
 * Copyright (c) 2021 JCA Electronics , Winnipeg, MB. All rights reserved.
 */
/* eslint-disable @typescript-eslint/no-explicit-any */

import { Vue, Component } from 'vue-property-decorator';
import NotificationStore from '@/store/modules/notifications';
import { getModule } from 'vuex-module-decorators';
import { NotificationMessageType } from '@/flightpath-components/models/NotificationMessageType';
import { NotificationPayload } from '@/models/NotificationPayload';

/**
 * Mixin Used For Tracking last modified for a View
 */

@Component
export default class LastModifiedMixIn extends Vue {
  notificationStore = getModule(NotificationStore, this.$store);
  type: NotificationMessageType[] = [];
  lastModifiedDate: Date | null = null;
  seen: Array<string> = [];

  mounted() {
    this.lastModifiedDate = this.lastModified;

    this.clearCounter();
    this.clearNotifications();
  }

  destroyed() {
    this.updateLastModified();
    this.clearCounter();
    this.clearNotifications();
  }

  isNew(date: any, id: string) {
    const compareDate = new Date(Date.parse(date));
    return (this.lastModifiedDate == null || compareDate.getTime() > this.lastModifiedDate.getTime()) && !this.seen.includes(id);
  }

  updateSelected(id: string) {
    if (!this.seen.includes(id)) this.seen.push(id);
  }

  updateLastModified() {
    if (this.$options.name != undefined) {
      this.notificationStore.updateLastModified(this.$options.name);
      this.lastModifiedDate = this.lastModified;
      console.log(this.lastModifiedDate);
    }
  }

  get lastModified(): Date | null {
    if (this.$options.name != undefined) {
      const result = this.notificationStore.lastModifiedState;
      if (!result.hasOwnProperty(this.$options.name)) return null;
      return new Date(result[this.$options.name]) ?? null;
    }
    return null;
  }

  updateCounter(type: NotificationMessageType, value: boolean) {
    if (this.$options.name != undefined) this.notificationStore.updateCounterNotification({ Type: type.toString(), Value: value });
  }

  clearCounter() {
    this.type.forEach(element => {
      this.updateCounter(element, false);
    });
  }

  countByType(payload: NotificationMessageType): number {
    if (!this.notificationStore.notificationCount.hasOwnProperty(payload.toString())) return 0;
    return this.notificationStore.notificationCount[payload];
  }

  clearNotifications() {
    this.type.forEach(element => {
      this.notificationStore.updateCount({ Type: element.toString(), Value: 0 });
    });
  }

  updateNotificationCount(payload: NotificationPayload<number>) {
    this.notificationStore.updateCount(payload);
  }

  incrementNotificationCount(type: NotificationMessageType) {
    this.notificationStore.incrementCount(type);
  }
}
